import React from "react";
import { useLocation, Route } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE_LOGIN, ROUTE_PANEL } from "../routes/routesConstants";
import { isUserInRole } from "../../commonFunctions/commonFunctions";
import { useSelector } from "react-redux";
import { selectLoadingUserRoles, selectUserRoles, selectUserSuperAdmin } from "../../redux/authentication/selectors";
import { CircularProgress } from "@material-ui/core";

 function PrivateRoute (props) {
      const location = useLocation();
      const { allowedRoles = ["*"], authed, redirectRoute = ROUTE_PANEL } = props;
      const userRoles = useSelector(selectUserRoles);
      const userSuperAdmin = useSelector(selectUserSuperAdmin)
      const loadingUserData = useSelector(selectLoadingUserRoles)
      const isAllowed = allowedRoles.some(x => x === "*"  || isUserInRole(x, userRoles, userSuperAdmin));
      const isLoading = loadingUserData === "loading" || loadingUserData === "idle"

      if(!authed()){
            return <Redirect to={{pathname: ROUTE_LOGIN, state:{from: location.pathname, search: location.search}}}/> 
      } else{
            if(isLoading){
                  return(
                  <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "40vh"}}>
                        <CircularProgress></CircularProgress>
                  </div>
                  )
            }
            else if(isAllowed){
                  return <Route path={props.path} render={()=>props.component}></Route>
            }

            else{
                  return <Redirect to={redirectRoute} state={{from: location.pathname, search: location.search}}/> 
            }
 
      }
}

export { PrivateRoute };